import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit {
  title: string;
  message: string;
  closeBtnName: string;
  submitBtnName: string;
  onClose: Function;
  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit() {}

  onSubmit() {
    this.onClose(true);
  }
}
